export const SET_LOGIN_USERNAME = "SET_LOGIN_USERNAME";
export const SET_LOGIN_FULLNAME = "SET_LOGIN_FULLNAME";
export const SET_LOGIN_AVATAR_URL = "SET_LOGIN_AVATAR_URL";
export const SET_LOGIN_EXTRA_INFO = "SET_LOGIN_EXTRA_INFO";
export const RESET_LOGIN_EXTRA_INFO = "RESET_LOGIN_EXTRA_INFO";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const RESET_CURRENT_USER = "RESET_CURRENT_USER";
